import React, { useState } from "react";
import { useDispatch } from "react-redux";
import * as api from "../../../redux/api/conference/conference_api";
import * as types from "../../../redux/constants/conference_constants";
import { Button, Spinner } from "@material-tailwind/react";
import ConfirmPayment from "../../../common/shared/ConfirmPayment";

function ConferencePaymentButton({ amount, year, id, total }) {
  const [loading, setLoading] = useState(false);
  const [confirm, setConfirm] = useState(false);

  const dispatch = useDispatch();
  const handleConfirm = () => setConfirm(!confirm);

  const handleLive = async (e) => {
    e.preventDefault();

    setLoading(true);

    const formData = {
      amount,
      year,
      id,
      total,
      method: 1,
    };

    try {
      const response = await api.updateConference(formData);
      const { error, data } = response;

      console.log("response", response);

      if (error) {
        setLoading(false);
        dispatch({ type: types.CONFERENCE_PAYMENT_FAILURE, payload: error });
      } else {
        window.location.href = data.receipt.url;
      }
    } catch (error) {
      window.location.reload();
      console.log(error);
    }
  };

  return (
    <>
      <Button color="pink" onClick={handleConfirm}>
        {loading ? <Spinner color="white" /> : "Make Payment"}
      </Button>

      {confirm && (
        <ConfirmPayment
          open={confirm}
          setOpen={setConfirm}
          title="Electronic"
          amount={total}
          loading={loading}
          handleConfirm={(e) => handleLive(e)}
          handleClose={handleConfirm}
        />
      )}
    </>
  );
}

export default ConferencePaymentButton;
